import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Box from '@material-ui/core/Box';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  button: {
    marginTop: 16,
  },
  label: {
    ...theme.typography.body2,
    color: theme.palette.primary.main,
  },
  popper: {
    zIndex: 998,
    width: 300,
    background: 'white',
    border: `1px solid #ECECEC`,
    borderRadius: 10,
    boxShadow: '0 2px 14px 0 rgba(0,0,0,0.05)',
    marginTop: -20,
    marginLeft: 10,
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '100% 100%',
      },
    },
  },
  arrow: {
    overflow: 'hidden',
    position: 'absolute',
    width: '1em',
    marginTop: '24px !important',
    height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */,
    boxSizing: 'border-box',
    color: '#FFFFFF',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: '100%',
      height: '100%',
      border: `1px solid #ECECEC`,
      boxShadow: '0 2px 14px 0 rgba(0,0,0,0.05)',
      backgroundColor: 'currentColor',
      transform: 'rotate(45deg)',
    },
  },
  contentWrapper: {
    padding: 12,
  },
}));

const GaugeAboutButton = ({ data }) => {
  const [assessmentResultsSiteCopy] = useSiteCopySelector([
    'assessment-results',
  ]);
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const arrowRef = useRef(null);
  const classes = useStyles();

  const handleClick = () => setOpen(!open);

  return (
    <>
      <ButtonBase
        disableRipple
        onClick={handleClick}
        className={classes.button}
        ref={anchorRef}
      >
        <Typography className={classes.label}>
          {_get(assessmentResultsSiteCopy, 'pageCopy.scoreHelperLabel')}
        </Typography>
      </ButtonBase>
      <Popper
        id="assessment-results-about"
        className={classes.popper}
        placement="right-start"
        anchorEl={anchorRef.current}
        open={open}
        modifiers={{
          arrow: {
            enabled: true,
            element: arrowRef.current,
          },
        }}
      >
        <>
          <span className={classes.arrow} ref={arrowRef} />
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Box className={classes.contentWrapper}>
              <RichTextReactRenderer
                data={data}
                component="p"
                paragraphVariant="overline"
              />
            </Box>
          </ClickAwayListener>
        </>
      </Popper>
    </>
  );
};

GaugeAboutButton.propTypes = {
  data: PropTypes.object,
};

export default GaugeAboutButton;
